<div class="dialog-header">
	<div class="header-title"><span style="font-size: 145%;">Create Message</span></div>

	<button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
		<mat-icon>clear</mat-icon>
	</button>
</div>

<div class="middle-content activity-dialog" [ngClass]="{'disabled-content': loadingSpinner}">

	<form #projectActivityForm="ngForm">
		<div class="form-block">
			<div class="form-row">
				<div class="icon-block">
					<mat-icon>format_list_bulleted</mat-icon>
				</div>
				<div class="field-block">

					<p-dropdown [ngModelOptions]="{standalone: true}" [options]="types" [(ngModel)]="selectedType"
						optionLabel="name" appendTo="body" panelStyleClass="create-message-dropdown"></p-dropdown>
				</div>
			</div>
		</div>
		<div class="save-btn-block">
			<button mat-button class="save-btn" (click)="createMessageButton()" tabindex="1" type="submit">
				<span *ngIf="!loadingSpinner">Create</span>
				<lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
			</button>
		</div>
	</form>
</div>